import { LoaderSpinner } from "./LoaderSpinner";

interface LoadingOverlayProps {
	message?: string;
	isSpinner?: boolean;
	opacity?: 5 | 10 | 20;
}

export const LoadingOverlay = ({
	message,
	isSpinner = false,
	opacity = 20,
}: LoadingOverlayProps): JSX.Element => (
	<div
		className={`fixed inset-0 bg-black/${opacity} z-50 flex items-center justify-center`}
	>
		{(isSpinner || message) && (
			<div className="bg-white p-4 rounded-lg shadow-lg">
				{isSpinner && <LoaderSpinner size={8} />}
				{message && <p className="mt-2 text-sm text-gray-600">{message}</p>}
			</div>
		)}
	</div>
);
